import React from 'react';
import { Card, Alert, Button, Badge } from 'react-bootstrap';
import { FaBrain, FaCheckCircle, FaClock, FaTimes, FaSpinner, FaList } from 'react-icons/fa';
import Spinner from '../Spinner';
import { safeRenderValue } from './utils/logsUtils';

const AnalysisSection = ({
  showAnalysisSection,
  fetchingAnalysis,
  analysisExecutionArn,
  analysisResult,
  analysisPollingActive,
  fetchingAnalysisStatus,
  executionArn,
  onClose
}) => {
  if (!showAnalysisSection) return null;

  return (
    <Card className="logs-card mb-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="section-heading">
            <FaBrain className="me-2" />
            Execution Analysis with AI
            {fetchingAnalysisStatus && analysisPollingActive && <FaSpinner className="fa-spin ms-2" />}
            {!analysisPollingActive && analysisResult && (
              <Badge bg={analysisResult.success ? 'success' : 'danger'} className="ms-2">
                {analysisResult.success ? 'Complete' : 'Failed'}
              </Badge>
            )}
          </h2>
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={onClose}
          >
            <FaTimes />
          </Button>
        </div>
      </Card.Header>
      <Card.Body style={{ minHeight: '300px', maxHeight: '70vh', overflowY: 'auto' }}>
        {fetchingAnalysis && (
          <div className="text-center py-4">
            <Spinner />
            <p className="mt-3">Initiating analysis...</p>
          </div>
        )}

        {analysisExecutionArn && !analysisResult && analysisPollingActive && (
          <Alert variant="info" className="mb-3">
            <div className="d-flex align-items-center">
              <FaClock className="me-2" />
              <div>
                <strong>Analysis in progress</strong>
                <div className="small">
                  Analyzing execution: {executionArn?.split(':').pop()}
                </div>
                {analysisExecutionArn && (
                  <div className="small text-muted mt-1">
                    Analysis Execution ID: {analysisExecutionArn.split(':').pop()}
                  </div>
                )}
                {fetchingAnalysisStatus && analysisPollingActive && (
                  <div className="small">
                    <FaSpinner className="fa-spin me-1" />
                    Checking analysis status...
                  </div>
                )}
              </div>
            </div>
          </Alert>
        )}

        {analysisResult && (
          <div>
            {analysisResult.success ? (
              <div>
                <Alert variant="success" className="mb-3">
                  <FaCheckCircle className="me-2" />
                  Analysis completed successfully!
                </Alert>
                
                {analysisResult.agentOutput && (
                  <div className="mb-4">
                    <h5 className="mb-3">
                      <FaBrain className="me-2" />
                      Agent Analysis Output
                    </h5>
                    <div className="info-field-value">
                      <div className="bg-light p-3 rounded border">
                        <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          {safeRenderValue(analysisResult.agentOutput)}
                        </pre>
                      </div>
                    </div>
                  </div>
                )}

                {analysisResult.executionSummary && (
                  <div className="mb-4">
                    <h5 className="mb-3">
                      <FaList className="me-2" />
                      Analysis Summary
                    </h5>
                    <div className="info-field-value">
                      <div className="bg-light p-3 rounded border">
                        <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          {safeRenderValue(analysisResult.executionSummary)}
                        </pre>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <Alert variant="danger">
                <FaTimes className="me-2" />
                Analysis failed: {analysisResult.error}
              </Alert>
            )}
          </div>
        )}

        {!fetchingAnalysis && !analysisExecutionArn && !analysisResult && (
          <div className="text-center py-4">
            <FaBrain size={48} className="text-muted mb-3" />
            <p>Click "Analyze Execution with Agent" to start AI-powered analysis of the execution.</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default AnalysisSection;
